import { render, staticRenderFns } from "./PageTitle.vue?vue&type=template&id=b8d5a606&scoped=true&"
import script from "./PageTitle.vue?vue&type=script&lang=js&"
export * from "./PageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d5a606",
  null
  
)

export default component.exports